import React from 'react';
import Relay from 'react-relay';

class CircleDashboard extends React.Component {

    constructor(props){
        super(props)
    }

    calculateModeStats(circles) {
        let modes = [];

        circles.forEach(circle => {
            let mode = circle.node.mode ;
            modes.push(mode);
        });

        let counts = {};

        for(var i = 0; i< modes.length; i++) {
            var num = modes[i];
            counts[num] = counts[num] ? counts[num]+1 : 1;
        }

        let tab = [];

        for (var count in counts) {
            let percentage = Math.round(counts[count] * 100 / modes.length);
            tab.push([count, counts[count],percentage]);
        }

        return tab;
    }

    render(){

        let circles = this.props.viewer.circles.edges;

        let modes = this.calculateModeStats(circles);

        return(
            <div>
                <table className="table table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Privacy</th>
                            <th>Nb of circles</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            modes.map((mode, index) => {
                                return (<tr key={index}><td>{mode[0]}</td><td>{mode[1]}</td><td>{mode[2]}</td></tr>)
                            }
                            )}
                    </tbody>
                </table>
            </div>
        )

    }

}

// to validate the values passed in props like number, string, DOM elements, arrays or fragment 
CircleDashboard.propTypes = ({
    children: React.PropTypes.node
});

export default Relay.createContainer(CircleDashboard, {
    fragments: {
        viewer: () => Relay.QL`
            fragment on Viewer {
                circles(last: 1000) {
                    edges {
                      node {
                        mode
                        creation_status {
                          status
                          reason
                        }
                      }
                    }
                  }
            }`
    }
});


// WEBPACK FOOTER //
// ./src/pages/Dashboard/CirclesDashboard.js